import { fromJS } from 'immutable';

export const SET_SUBMITTED = 'modules/axp-travel-search-hotels/SET_SUBMITTED';
export const SET_TRAVELER_MODAL_OPEN = 'modules/axp-travel-search-hotels/SET_TRAVELER_MODAL_OPEN';
export const SET_TRAVELER_MODAL_CLOSE = 'modules/axp-travel-search-hotels/SET_TRAVELER_MODAL_CLOSE';

export const setSubmitted = (isSubmitted = true) => ({
  type: SET_SUBMITTED,
  isSubmitted,
});

export const setIsTravelerModalOpen = () => ({
  type: SET_TRAVELER_MODAL_OPEN,
});

export const setIsTravelerModalClose = () => ({
  type: SET_TRAVELER_MODAL_CLOSE,
});

export const initialState = fromJS({
  isSubmitted: false,
  isTravelerModalOpen: false,
});

// eslint-disable-next-line default-param-last -- required
const formReducer = (state = initialState, action) => {
  switch (action && action.type) {
    case SET_SUBMITTED: {
      return state.set('isSubmitted', action.isSubmitted);
    }
    case SET_TRAVELER_MODAL_OPEN: {
      return state.set('isTravelerModalOpen', true);
    }
    case SET_TRAVELER_MODAL_CLOSE: {
      return state.set('isTravelerModalOpen', false);
    }
    default:
      return state;
  }
};

export default formReducer;
